import { inject, Injectable } from '@angular/core';
import { queryOptions } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileQueryService {
  #queryKey = 'sp-user';
  #userService = inject(UserService);
  constructor() {}

  getCurrentProfileOptions() {
    return queryOptions({
      queryKey: [`${this.#queryKey}/current`],
      queryFn: () => lastValueFrom(this.#userService.getCurrentUser()),
      staleTime: 5 * 1000 * 60, // 5mins
    });
  }
}
